export class SmsDescriptionHelper {
    static count(unicodeString: string): number {
        if (!unicodeString) {
            return 0;
        }
        unicodeString = unicodeString.replace("\r\n", "a");
        const isPersian = this.isPersian(unicodeString);
        let msgCount = 0;
        const increaseBy = unicodeString.includes("{*}") ? 10 : 0;
        const strLength = unicodeString.split("").length + increaseBy;

        if (isPersian === true && strLength <= 70) {
            msgCount = 1;
        } else if (isPersian === true && strLength > 70) {
            msgCount = Math.ceil(strLength / 67.0);
        } else if (isPersian === false && strLength <= 160) {
            msgCount = 1;
        } else if (isPersian === false && strLength > 160) {
            msgCount = Math.ceil(strLength / 157.0);
        }

        return isPersian ? msgCount : msgCount * 2;
    }

    static isPersian(content: string): boolean {
        if (!content) {
            return true;
        }
        let unicodeString = content;
        unicodeString = unicodeString.replace("\r\n", "a");
        return this.fixText(unicodeString);
    }

    private static fixText(unicodeString: string): boolean {
        const maxAnsiCode = 255;
        let isPersian = true;
        if (unicodeString !== "") {
            isPersian =
                unicodeString
                    .split("")
                    .map((c) => c.charCodeAt(0))
                    .filter((c) => c > maxAnsiCode).length > 0;
        } else {
            isPersian = true;
        }
        return isPersian;
    }
}

export function formatTemplate(template: string, args: string[]) {
    // provider an empty string for arguments
    // this is necessary for preventing errors
    if (!args || args.length === 0) {
        args = Array(100).map((_) => "");
    }

    for (let i = 0; i < args?.length ?? 0; i++) {
        const regexp = new RegExp("\\{" + i + "\\}", "gi");
        template = template.replace(regexp, args[i] ?? "");
    }
    return template;
}
